import React from 'react';
import PropTypes from 'prop-types';
import useCmsImage from '@utils/useCmsImage';
import { Ta11yImage } from '@core/index';
import './PromoTeaser.scss';

export function PromoTeaser({ headline = '', text = '', imageRef, imgAlt = '' }) {
  const image = useCmsImage(imageRef);

  return (
    <div className="promo-teaser rounded-3 overflow-hidden">
      <div className="row g-0">
        <div className="col-12 col-lg-6 col-xl-8 col-xxl-8 d-flex flex-column p-32 order-1 order-lg-1">
          {headline && <h3 className="ek-h2 text-primary mb-24">{headline}</h3>}
          {text && <p className="ek-copy-16-regular text-primary m-0">{text}</p>}
        </div>
        <div className="col-12 col-lg-6 col-xl-4 col-xxl-4 p-0 order-2 order-lg-2 align-self-end">
          <Ta11yImage
            imageContent={image}
            alt={imgAlt}
            className="promo-teaser__image"
          />
        </div>
      </div>
    </div>
  );
}

PromoTeaser.propTypes = {
  headline: PropTypes.string,
  text: PropTypes.string,
  imageRef: PropTypes.string.isRequired,
  imgAlt: PropTypes.string
};

export default PromoTeaser;
